// src/GAdsPageView.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function GAdsPageView() {
  const location = useLocation();

  useEffect(() => {
    if (!window.gtag) return;
    // Send a pageview when the route changes
    window.gtag('config', 'AW-17474107567', {
      page_path: location.pathname + location.search,
    });
  }, [location]);

  return null;
}
